import * as ActionTypes from './InvoiceActionTypes';

export default function invoiceReducer(
    state: any = {
        invoice: { renderedTemplate: '' },
        newImport: { availableLegalEntities: [] },
        import: { feedback: [] },
        invoicesFilter: {
            availableCustomers: [],
            availableInvoiceStatuses: [],
            availableInvoiceDateTypes: [],
            availableInvoiceTypes: []
        },
        invoices: { list: [], totals: [] },
        newPayment: {},
        payments: [],
        newInvoice: { renderedTemplate: '' },
        newCreditInvoice: { renderedTemplate: '' },
        invoicables: {
            invoicableSellers: [],
            invoicableClients: [],
            invoicablePrivateCustomers: [],
            invoicableCommercialCustomers: []
        },
        filter: {
            availableRegions: [],
            availableBrokerChains: [],
            availableCountries: [],
            availableLegalEntities: [],
            availableInvoiceInterval: []
        }
    },
    action: { type: string; result: any }
) {
    switch (action.type) {
        case ActionTypes.GET_INVOICABLES_FILTER_SUCCESS:
            return {
                ...state,
                filter: action.result
            };

        case ActionTypes.GET_INVOICABLES_SUCCESS:
            return {
                ...state,
                invoicables: action.result
            };

        case ActionTypes.GET_NEW_INVOICE_SUCCESS:
            return {
                ...state,
                newInvoice: action.result
            };

        case ActionTypes.GET_NEW_CREDIT_INVOICE_SUCCESS:
            return {
                ...state,
                newCreditInvoice: action.result
            };

        case ActionTypes.GET_INVOICES_SUCCESS:
            return {
                ...state,
                invoices: {
                    list: action.result.invoices,
                    totals: action.result.totals
                }
            };

        case ActionTypes.GET_INVOICES_FILTER_SUCCESS:
            return {
                ...state,
                invoicesFilter: action.result
            };

        case ActionTypes.GET_NEW_PAYMENT_SUCCESS:
            return {
                ...state,
                newPayment: action.result
            };

        case ActionTypes.GET_PAYMENTS_SUCCESS:
            return {
                ...state,
                payments: action.result
            };

        case ActionTypes.NEW_IMPORT_PAYMENTS_SUCCESS:
            return {
                ...state,
                newImport: action.result
            };

        case ActionTypes.IMPORT_PAYMENTS_SUCCESS:
            return {
                ...state,
                import: action.result
            };

        case ActionTypes.GET_INVOICE_SUCCESS:
            return {
                ...state,
                invoice: action.result
            };

        case ActionTypes.CREATE_INVOICE_SUCCESS:
            return {
                ...state,
                newInvoice: {
                    renderedTemplate: action.result
                }
            };

        case ActionTypes.CREATE_CREDIT_INVOICE_SUCCESS:
            return {
                ...state,
                newCreditInvoice: {
                    renderedTemplate: action.result
                }
            };
        case ActionTypes.MARK_AS_VOID_SUCCESS:
            return {
                ...state,
                newInvoice: {
                    ...state.newInvoice,
                    markedAsVoid: action.result
                }
            };
        case ActionTypes.TRY_INVOICE_AGAIN_SUCCESS:
            var newstate = {
                ...state
            };

            if (state.invoicables) {
                newstate.invoicables = {
                    ...state.invoicables,
                    invoicableBrokerFirmsWithSeperateInvoiceReceiver: [
                        ...state.invoicables.invoicableBrokerFirmsWithSeperateInvoiceReceiver
                    ],
                    invoicableCompaniesWithSeperateInvoiceReceiver: [
                        ...state.invoicables.invoicableCompaniesWithSeperateInvoiceReceiver
                    ],
                    invoicableCompanies: [...state.invoicables.invoicableCompanies],
                    invoicableBrokerFirms: [...state.invoicables.invoicableBrokerFirms],
                    invoicableSellers: [...state.invoicables.invoicableSellers],
                    pendingInvoices: [
                        ...state.invoicables.pendingInvoices.filter(
                            (invoice: any) => invoice.id !== action.result
                        )
                    ]
                };
            }

            return newstate;
        default:
            return state;
    }
}
